import { defineAsyncComponent } from 'vue';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const ProviderPicker = defineAsyncComponent(() => import('@/js/comparisons/ProviderPicker.vue'));
const Converter = defineAsyncComponent(() => import('@/js/cryptocurrencies/converter/Converter.vue'));
const TopExchangesTippy = defineAsyncComponent(() => import('@/js/components/Tippy/TopExchangesTippy/TopExchangesTippy.vue'));

app.component('Converter', Converter);
app.component('TopExchangesTippy', TopExchangesTippy);
app.component('ProviderPicker', ProviderPicker);

mountApp();
